import { Utils } from '../utils';
export class InteractionComponent {
    id;
    description;
    constructor(cfg = {}) {
        const { id, description } = cfg;
        this.id = id;
        this.description = description;
    }
    asVersion(version = '1.0.3') {
        const result = {
            id: this.id,
            description: this.description
        };
        return result;
    }
    getLangDictionaryValue = Utils.getLangDictionaryValue;
    static fromJSON(icJSON) {
        const _ic = JSON.parse(icJSON);
        return new InteractionComponent(_ic);
    }
}
